import {AfterViewInit, Component, OnInit} from '@angular/core';

declare var require: any;
// tslint:disable-next-line:variable-name
let Quill: any = null;

// uses quill, view https://quilljs.com/docs/quickstart/
@Component({
    selector: 'app-editor',
    templateUrl: './editor.component.html',
    styleUrls: ['./editor.component.css']
})
export class EditorComponent implements OnInit, AfterViewInit {
    quill;
    noRedo = true;
    noUndo = true;
    constructor() {
        if (!Quill) {
            Quill = require('quill');
            console.log('Quill:', Quill);
        }
    }

    ngOnInit() {
    }

    undo() {
        this.quill.history.undo();
        this.noUndo = this.quill.history.stack.undo.length === 0;
        this.noRedo = false;
    }

    ngAfterViewInit() {
        const toolbarOptions = [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],

            [{'header': 1}, {'header': 2}],               // custom button values
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
            [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
            [{'direction': 'rtl'}],                         // text direction

            [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
            [{'header': [1, 2, 3, 4, 5, 6, false]}],

            [{'color': []}, {'background': []}],          // dropdown with defaults from theme
            [{'font': []}],
            [{'align': []}],

            [{'undo': []}]

            ['clean']                                         // remove formatting button
        ];

        const that = this;
        this.quill = new Quill('#editor', {
            modules: {
                toolbar: toolbarOptions,
                history: {
                    delay: 2000,
                    maxStack: 500,
                    userOnly: true
                }
            },
            placeholder: 'Compose an epic...',
            theme: 'snow'
        });
        this.quill.on('text-change', (delta, oldDelta, source) => {
            this.noRedo = this.quill.history.stack.redo.length === 0;
            this.noUndo = this.quill.history.stack.undo.length === 0;
            if (source === 'api') {
                console.log('An API call triggered this change.');
            } else if (source === 'user') {
                console.log('A user action triggered this change.');
            }
        });
    }
    redo() {
        this.quill.history.redo();
        this.noUndo = false;
        this.noRedo = this.quill.history.stack.redo.length === 0;
        console.log(this.quill.history);
    }
    getContent() {
        return this.quill.container.firstChild.innerHTML;
    }
    setContent(content: string) {
        this.quill.container.firstChild.innerHTML = content;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/editor/editor.component.ts